import { render, staticRenderFns } from "./sensorUpload.vue?vue&type=template&id=6519495a&scoped=true"
import script from "./sensorUpload.vue?vue&type=script&lang=js"
export * from "./sensorUpload.vue?vue&type=script&lang=js"
import style0 from "./sensorUpload.vue?vue&type=style&index=0&id=6519495a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6519495a",
  null
  
)

export default component.exports